export class LookupUploadResponseModel {
    numOfAddedElements;
    numOfMergedElements;
    numOfSkippedElements;
    lookupListId;
}
//# sourceMappingURL=lookup-upload-response.js.map